import React, { useState } from "react";
import { get, isEmpty } from "lodash";
import { Form, Button, Image } from "react-bootstrap";
import { Formik, Field } from "formik";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  FieldInput,
  SearchableList,
  FieldDropSide,
  DatePicker,
  ManageReportLayout,
  MultiSelectDropdown,
  LoaderWrapper,
} from "../../../components";
import {
  manageReportsFormNames,
  formFields,
  usDateFormat,
  ssnMasking,
  clearFieldValues,
} from "../../../utils";
import {
  GetCompensationHourLoansReport,
  getCompaniesDropDown,
  getPlansDropDown,
  DownloadCompensationHourLoansReport,
  getSponsorOrganizationList,
  getMasterPlanList,
} from "../../../services";
import { useDeepEffect, useRequest } from "../../../abstracts";
import ExcelImage from "../../../styles/exportimg.PNG";
import * as fileSaver from "file-saver";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ColumnMenu } from "./columnMenu";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { GridInnerFilters } from "../../../components/GridInnerFilters/GridInnerFilters";

const allOption = { label: "All", value: null };

const selectOne = { label: "Select One", value: null };

class KendoGridDecimalCell extends React.Component {
  render() {
    const value = this.props.dataItem[this.props.field];
    return <td> {value ? `$ ${parseFloat(value).toFixed(2)}` : `0`}</td>;
  }
}
class ProductNameHeader extends React.Component {
  render() {
    return (
      <a className="k-link" onClick={this.props.onClick}>
        <span title={this.props.title}>{this.props.title}</span>
        {this.props.children}
      </a>
    );
  }
}

const emptycol = [
  {
    value: 0,
    label: "",
    className: "",
    columnName: "",
    field: "",
    width: 0,
    dataType: "",
    field1: "",
  },
];
const columns = [
  {
    value: 1,
    label: "Company name",
    className: "column-companyName",
    columnName: "companyName",
    field: "companyName",
    width: 144,
    dataType: "alphaNumeric",
    field1: "companyName",
  },
  {
    value: 2,
    label: "Plan ID",
    className: "column-planId",
    columnName: "rkPlanNumber",
    field: "rkPlanNumber",
    width: 120,
    dataType: "alphaNumeric",
    field1: "rkPlanNumber",
  },
  {
    value: 3,
    label: "Plan year start date",
    className: "column-planYearStart",
    columnName: "planYearStart",
    field: "planYearStart",
    width: 185,
    dataType: "date",
    field1: "planYearStartFrom",
    field2: "planYearStartTo",
  },
  {
    value: 4,
    label: "Plan year end date",
    className: "column-planYearEnd",
    dataType: "date",
    columnName: "planYearEnd",
    field: "planYearEnd",
    width: 185,
    field1: "planYearEndFrom",
    field2: "planYearEndTo",
  },
  {
    value: 5,
    label: "Payroll date",
    className: "column-payrollPaidDate",
    columnName: "payrollDate",
    field: "payrollDate",
    width: 183,
    dataType: "date",
    field1: "payrollDateFrom",
    field2: "payrollDateTo",
  },
  {
    value: 6,
    label: "Employee ID",
    className: "column-employeeNo",
    columnName: "employeeNo",
    field: "employeeNo",
    width: 144,
    dataType: "alphaNumeric",
    field1: "employeeNo",
  },
  {
    value: 7,
    label: "SSN",
    className: "column-ssn",
    columnName: "ssn",
    field: "ssn",
    width: 183,
    dataType: "alphaNumeric",
    field1: "ssn",
  },
  {
    value: 8,
    label: "First name",
    className: "column-firstName",
    columnName: "firstName",
    field: "firstName",
    width: 164,
    dataType: "alphaNumeric",
    field1: "firstName",
  },
  {
    value: 9,
    label: "Last name",
    className: "column-lastName",
    columnName: "lastName",
    field: "lastName",
    width: 169,
    dataType: "alphaNumeric",
    field1: "lastName",
  },
  {
    value: 10,
    label: "Date of Birth",
    className: "column-dateOfBirth",
    columnName: "dateOfBirth",
    field: "dateOfBirth",
    width: 169,
    dataType: "date",
    field1: "dateOfBirthFrom",
    field2: "dateOfBirthTo",
  },
  {
    value: 11,
    label: "Currently Employed",
    className: "column-currentlyEmployed",
    columnName: "currentlyEmployed",
    field: "currentlyEmployed",
    width: 169,
    dataType: "boolean",
    field1: "currentlyEmployed",
    //field2: "dateOfBirthTo",
  },
  {
    value: 12,
    label: "Pay Period Plan Compensation",
    className: "column-payPeriodPlanCompensation",
    columnName: "payPeriodPlanCompensation",
    field: "payPeriodPlanCompensation",
    width: 180,
    dataType: "amount",
    field1: "payPeriodPlanCompensationFrom",
    field2: "payPeriodPlanCompensationTo",
  },
  {
    value: 13,
    label: "YTD Gross Compensation-File",
    className: "column-yTDGrossCompensationFile",
    columnName: "ytdGrossCompensationFile",
    field: "ytdGrossCompensationFile",
    width: 200,
    dataType: "amount",
    field1: "ytdGrossCompensationFileFrom",
    field2: "ytdGrossCompensationFileTo",
  },
  {
    value: 14,
    label: "YTD Gross Compensation calculated ",
    className: "column-ytdGrossCompensationCalculated ",
    columnName: "ytdGrossCompensationCalculated",
    field: "ytdGrossCompensationCalculated",
    width: 250,
    dataType: "amount",
    field1: "yTDGrossCompensationCalculatedFrom",
    field2: "yTDGrossCompensationCalculatedTo",
  },
  {
    value: 15,
    label: "YTD Plan Eligible Compensation - File",
    className: "column-ytdPlanEligibleCompensationFile",
    columnName: "ytdPlanEligibleCompensationFile",
    field: "ytdPlanEligibleCompensationFile",
    width: 250,
    dataType: "amount",
    field1: "ytdPlanEligibleCompensationFileFrom",
    field2: "ytdPlanEligibleCompensationFileTo",
  },
  {
    value: 16,
    label: "YTD Plan Eligible Compensation - Calculated",
    className: "column-ytdPlanEligibleCompensationCalculated",
    columnName: "ytdPlanEligibleCompensationCalculated",
    field: "ytdPlanEligibleCompensationCalculated",
    width: 289,
    dataType: "amount",
    field1: "ytdPlanEligibleCompensationCalculatedFrom",
    field2: "ytdPlanEligibleCompensationCalculatedTo",
  },
  {
    value: 17,
    label: "Pay Period Hours",
    className: "column-payPeriodHours",
    columnName: "payPeriodHours",
    field: "payPeriodHours",
    width: 160,
    dataType: "numeric",
    field1: "payPeriodHoursFrom",
    field2: "payPeriodHoursTo",
  },
  {
    value: 18,
    label: "Pay Period Hours Equivalency",
    className: "column-payPeriodHoursEquivalency",
    columnName: "payPeriodHoursEquivalency",
    field: "payPeriodHoursEquivalency",
    width: 160,
    dataType: "boolean",
  },
  {
    value: 19,
    label: "YTD Hours - File",
    className: "column-ytdHoursFile",
    columnName: "ytdHoursFile",
    field: "ytdHoursFile",
    width: 210,
    dataType: "numeric",
    field1: "ytdHoursFileFrom",
    field2: "ytdHoursFileTo",
  },
  {
    value: 20,
    label: "YTD Hours – Calculated ",
    className: "column-ytdHoursCalculated",
    columnName: "ytdHoursCalculated",
    field: "ytdHoursCalculated",
    width: 210,
    dataType: "numeric",
    field1: "ytdHoursCalculatedFrom",
    field2: "ytdHoursCalculatedTo",
  },
  {
    value: 21,
    label: "YTD Hours – Equivalency",
    className: "column-ytdHoursEquivalency",
    columnName: "ytdHoursEquivalency",
    field: "ytdHoursEquivalency",
    width: 210,
    dataType: "numeric",
    field1: "ytdHoursEquivalencyFrom",
    field2: "ytdHoursEquivalencyTo",
  },
  {
    value: 22,
    label: "Anniversary Hours to Date",
    className: "column-anniversaryHourstoDate",
    columnName: "anniversaryHourstoDate",
    field: "anniversaryHourstoDate",
    width: 210,
    dataType: "numeric",
    field1: "anniversaryHourstoDateFrom",
    field2: "anniversaryHourstoDateTo",
  },
  {
    value: 23,
    label: "Prior Year Census Hours",
    className: "column-priorYearCensusHours",
    columnName: "priorYearCensusHours",
    field: "priorYearCensusHours",
    width: 210,
    dataType: "numeric",
    field1: "priorYearCensusHoursFrom",
    field2: "priorYearCensusHoursTo",
  },
  {
    value: 24,
    label: "Pre Entry Gross Compensation",
    className: "column-yTDGrossCompensationPriortoEligibility",
    columnName: "ytdGrossCompensationPriortoEligibility",
    field: "ytdGrossCompensationPriortoEligibility",
    width: 210,
    dataType: "amount",
    field1: "ytdGrossCompensationPriortoEligibilityFrom",
    field2: "ytdGrossCompensationPriortoEligibilityTo",
  },
  {
    value: 25,
    label: "Pay Period Loan Repayment",
    className: "column-payPeriodLoanRepayment",
    columnName: "payPeriodLoanRepayment",
    field: "payPeriodLoanRepayment",
    width: 210,
    dataType: "amount",
    field1: "payPeriodLoanRepaymentFrom",
    field2: "payPeriodLoanRepaymentTo",
  },
  {
    value: 26,
    label: "YTD Loan Repayment ",
    className: "column-ytdLoanRepayment ",
    columnName: "ytdLoanRepayment",
    field: "ytdLoanRepayment",
    width: 210,
    dataType: "amount",
    field1: "ytdLoanRepaymentFrom",
    field2: "ytdLoanRepaymentTo",
  },
];

const CompensationHoursLoansReport = (props) => {
  const formName = manageReportsFormNames.COMP_HOURS_LOANS_REPORT;
  const fields = formFields[formName];
  const [toggle, setToggle] = useState(false);
  const [final, setFinal] = useState(columns);
  const [planList, setPlanList] = useState([]);

  const today = new Date();
  const initialValues = {
    toDate: new Date(today.setDate(today.getDate())),
    fromDate: new Date(today.setDate(today.getDate() - 30)),
    [fields.nameOrSsn]: "",
  };

  const [filteredValues, setFilteredValues] = useState({
    from: 1,
    count: 10,
  });
  const [selectedColumns, setSelectedColumns] = useState(
    Array.from({ length: columns.length }, (_, i) => i + 1)
  );
  const [companyList, setCompanyList] = useState("");
  const [sponOrgList, setSponOrgList] = useState("");
  const [gridFilters, setGridFilters] = useState();
  const [isScroll, setIsScroll] = useState(false);
  const [tableContent, setTableContent] = useState([]);
  const [lastScrollTop, setLastScrollTop] = useState(null);
  const [pageCount, setPageCount] = useState(1);
  const [sorting, setSorting] = useState();
  const [dataLoading, setDataLoading] = useState(false);
  const [totalRecord, setTotalRecord] = useState(0);
  const [trigger, setTrigger] = useState(true);
  const { response: companies } = useRequest({
    method: getCompaniesDropDown,
    defaultResponse: [],
  });
  const { response: sponsors } = useRequest({
    method: getSponsorOrganizationList,
    defaultResponse: [],
  });
  const apiCall = (data) => {
    setDataLoading(true);
    GetCompensationHourLoansReport(data)
      .then((response) => {
        setDataLoading(false);
        setTableContent(response.getCompensationHoursLoansDetails);
        setTotalRecord(response.count);
        if (response.count > 0) {
          setIsScroll(true);
        }
      })
      .catch((error) => {
        setDataLoading(false);
        //handle error
      });
  };

  useDeepEffect(() => {
    if (!isEmpty(companyList) || !isEmpty(sponOrgList)) {
      setFilteredValues({
        ...filteredValues,
        innerFilters: gridFilters,
      });
      apiCall({ ...filteredValues, innerFilters: gridFilters });
    }
  }, [gridFilters]);

  const onSubmit = (values) => {
    setGridFilters(null);
    if (values.companyId !== null) {
      setCompanyList(values.companyName);
      setSponOrgList(values[fields.sponsorOrganizationName]);
      setPageCount(1);
      setIsScroll(true);
      //setTableContent([]);
      var filters = {
        companyId: values.companyId ? values.companyId : 0,
        sponsorOrganizationId: values.sponsorOrganizationId
          ? values.sponsorOrganizationId
          : 0,
        planId: values.companyId
          ? planList.length === 1
            ? planList[0].planId
            : !values.planId
            ? 0
            : values.planId
          : 0,
        masterPlanId: values.sponsorOrganizationId
          ? planList.length === 1
            ? planList[0].planId
            : !values.planId
            ? 0
            : values.planId
          : 0,
        nameOrSsn: values.nameOrSsn,
        fromDate: values.fromDate,
        toDate: values.toDate,
        from: 1,
        count: 20,
        innerFilters: null,
        selectedColumns: selectedColumns,
      };
      setFilteredValues(filters);
      // setToggle(!toggle);
      apiCall(filters);
    } else {
      setIsScroll(false);
      setTableContent([]);
      setCompanyList("");
      setSponOrgList("");
    }
  };

  const scrollHandler = (event) => {
    const e = event.nativeEvent;
    if (lastScrollTop === e.target.scrollTop) {
      return;
    }
    setLastScrollTop(e.target.scrollTop);
    if (
      e.target.scrollTop + 20 >=
      e.target.scrollHeight - e.target.clientHeight
    ) {
      if (isScroll) {
        var fromCount = pageCount * 20 + 1;
        var filters = {
          companyId: filteredValues.companyId,
          sponsorOrganizationId: filteredValues.sponsorOrganizationId,
          planId: filteredValues.planId,
          masterPlanId: filteredValues.masterPlanId,
          nameOrSsn: filteredValues.nameOrSsn,
          fromDate: filteredValues.fromDate,
          toDate: filteredValues.toDate,
          from: fromCount,
          count: 20,
          innerFilters: gridFilters,
        };
        setToggle(!toggle);
        setPageCount(pageCount + 1);
        setDataLoading(true);
        GetCompensationHourLoansReport(filters)
          .then((response) => {
            setDataLoading(false);
            if (response.getCompensationHoursLoansDetails.length === 0) {
              setIsScroll(false);
            } else {
              setTableContent([
                ...tableContent,
                ...response.getCompensationHoursLoansDetails,
              ]);
            }
          })

          .catch((error) => {
            setDataLoading(false);
            //handle error
          });
      }
    }
  };

  const showManageColumns = () => {
    let x = document.getElementsByClassName("manage-column-dropdown");
    let y = x[0].style.display;
    if (y === "none") {
      x[0].style.display = "block";
    } else {
      x[0].style.display = "none";
    }
  };
  const hideColumns = () => {
    setSelectedColumns(final.map((item) => item.value));
    let x = document.getElementsByClassName("manage-column-dropdown");
    let y = x[0].style.display;
    if (y === "block") {
      x[0].style.display = "none";
    } else {
      x[0].style.display = "block";
    }
  };
  document.addEventListener("mouseup", function (e) {
    let container = document.getElementsByClassName("manage-column-dropdown");
    let button = document.getElementsByClassName("column-header");
    if (container[0] && !container[0]?.contains(e.target)) {
      container[0].style.display = "none";
    }
  });

  const applyColumns = () => {
    if (selectedColumns.length >= 1) {
      setFinal(
        columns.filter((column) =>
          selectedColumns.map((x) => x).includes(column.value)
        )
      );
      setIsScroll(true);
    } else {
      setFinal(emptycol);
      setIsScroll(false);
    }
    hideColumns();
  };

  const exportReportFile = () => {
    var column = columns.filter(
      (column) => !final.map((item) => item.value).includes(column.value)
    );
    var data = column.map((item) => item.value);
    DownloadCompensationHourLoansReport({
      ...filteredValues,
      selectedColumns: data,
    })
      .then((response) => {
        var blob = new Blob([response], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fileSaver.saveAs(
          blob,
          `HoursCompLoansReport_${usDateFormat(new Date())}.xlsx`
        );
      })
      .catch((error) => {});
  };

  const renderValue = (value) => {
    value = value?.dataItem ? value.dataItem[value.field] : value;
    return <td>{value ? <div>{value}</div> : <div>-</div>}</td>;
  };
  const booleanFieldRender = (value) => {
    value = value?.dataItem ? value.dataItem[value.field] : value;
    let temp = "";
    if (value === true) temp = "True";
    else if (value === false) temp = "False";
    return renderValue(temp);
  };

  const numericFieldRender = (value) => {
    value = value?.dataItem ? value.dataItem[value.field] : value;
    return <td>{value ? <div>{value}</div> : <div>0</div>}</td>;
  };

  const dateFieldRender = (value) => {
    value = value?.dataItem ? value.dataItem[value.field] : value;
    return renderValue(usDateFormat(value));
  };

  const ssnGridCell = (props) => {
    var value = ssnMasking(props.dataItem.ssn);
    return renderValue(value);
  };

  const dateForm = (props) => {
    var value = usDateFormat(props.dataItem[props.field]);
    return renderValue(value);
  };

  return (
    <ManageReportLayout rptName="Compensation, Hours and Loans">
      <div className="w-100 reports-container min-width-200">
        <div className="min-width-200">
          <Formik
            initialValues={{
              ...initialValues,
            }}
            onSubmit={onSubmit}
            validateOnChange={false}
            validateOnBlur={false}
          >
            {({
              handleChange,
              setFieldValue,
              handleSubmit,
              setValues,
              setErrors,
              values,
              ...rest
            }) => {
              const onDaySelected = (fieldName, value) => {
                setFieldValue(fieldName, value);
              };
              const selectPlanOptions =
                planList && !isEmpty(values[fields.companyName])
                  ? [
                      allOption,
                      ...planList.map((plan, index) => ({
                        label: plan.planName,
                        value: index,
                      })),
                    ]
                  : planList && [
                      ...planList.map((plan, index) => ({
                        label: plan.planName,
                        value: index,
                      })),
                    ];
              const onCompanyChange = (value) => {
                setValues({
                  ...clearFieldValues({
                    values: values,
                    fieldsToClear: [fields.planId, fields.planName],
                  }),
                  [fields.companyId]:
                    value || value === 0
                      ? parseInt(companies[value].companyId)
                      : null,
                  [fields.companyName]:
                    value || value === 0
                      ? companies[value].companyName
                      : "Select One",
                });

                getPlansDropDown(get(companies[value], "companyId", 0))
                  .then((response) => {
                    setPlanList(response);
                    if (response.length === 1) {
                      setFieldValue([fields.planName], response[0]?.planName);
                    }
                  })
                  .catch((error) => {
                    //Handle Error
                  });
              };
              const OnSponsorChange = (value) => {
                setValues({
                  ...clearFieldValues({
                    values: values,
                    fieldsToClear: [fields.planId, fields.planName],
                  }),
                  [fields.sponsorOrganizationId]:
                    value || value === 0 ? parseInt(sponsors[value].id) : null,
                  [fields.sponsorOrganizationName]:
                    value || value === 0 ? sponsors[value].name : "Select One",
                });

                getMasterPlanList(get(sponsors[value], "id", 0))
                  .then((response) => {
                    setPlanList(response);
                    if (response.length === 1) {
                      setFieldValue([fields.planName], response[0]?.planName);
                    }
                  })
                  .catch((error) => {
                    //Handle Error
                  });
              };
              const onPlanChange = (value) => {
                if (value || value === 0) {
                  setFieldValue(
                    fields.planId,
                    parseInt(planList[value].planId)
                  );
                  setFieldValue(fields.planName, planList[value].planName);
                } else {
                  setFieldValue(fields.planId, null);
                  setFieldValue(fields.planName, "All");
                }
              };

              return (
                <Form
                  autoComplete="off"
                  className="mb-20 mt-10"
                  onSubmit={handleSubmit}
                  validated={!isEmpty(rest.errors)}
                >
                  <div className="d-flex  justify-content-between">
                    <div className="d-flex mr-4">
                      <Field
                        size="sm"
                        isRequired
                        label={`Sponsoring organization ${
                          !values[fields.companyName] ? "*" : ""
                        }`}
                        name={fields.sponsorOrganizationName}
                        value={values[fields.sponsorOrganizationName]}
                        placeholder="Select One"
                        direction="bottom"
                        disabled={values[fields.companyName]}
                        validate={(value) =>
                          ["", undefined, null, "Select One"].includes(value) &&
                          isEmpty(values[fields.companyName]) ? (
                            <div style={{ width: "150px" }}>
                              {" "}
                              Select a sponsoring organization or company{" "}
                            </div>
                          ) : null
                        }
                        popupContent={
                          <SearchableList
                            label="Select Sponsor Organization"
                            // options={sponsoringOrganisationList}
                            options={
                              sponsors && [
                                //selectOne,
                                ...sponsors.map((sponsor, index) => ({
                                  label: sponsor.name,
                                  value: index,
                                })),
                              ]
                            }
                            onSelect={(value) => OnSponsorChange(value)}
                            selectedValue={
                              values[fields.sponsorOrganizationName]
                            }
                          />
                        }
                        component={FieldDropSide}
                      />
                      <Field
                        size="sm"
                        isRequired
                        label={`Company Name ${
                          !values[fields.sponsorOrganizationName] ? "*" : ""
                        }`}
                        name={fields.companyName}
                        value={values[fields.companyName]}
                        placeholder="Select One"
                        direction="bottom"
                        disabled={values[fields.sponsorOrganizationName]}
                        validate={(value) =>
                          ["", undefined, null, "Select One"].includes(value) &&
                          isEmpty(values[fields.sponsorOrganizationName])
                            ? " "
                            : null
                        }
                        popupContent={
                          <SearchableList
                            label="Select Company"
                            options={
                              companies && [
                                //selectOne,
                                ...companies.map((company, index) => ({
                                  label: company.companyName,
                                  value: index,
                                })),
                              ]
                            }
                            onSelect={(value) => onCompanyChange(value)}
                            selectedValue={values[fields.companyName]}
                          />
                        }
                        component={FieldDropSide}
                      />
                      <div className="d-flex ml-4">
                        <Field
                          size="sm"
                          isRequired
                          label={`plan Id ${
                            !values[fields.companyName] ? "*" : ""
                          }`}
                          name={fields.planName}
                          value={
                            values[fields.planName]
                              ? values[fields.planName]
                              : values[fields.companyName] && "All"
                          }
                          placeholder="Select"
                          direction="bottom"
                          validate={(value) =>
                            values[fields.sponsorOrganizationName] &&
                            ["", undefined, null, "Select One"].includes(value)
                              ? "Select a plan"
                              : null
                          }
                          popupContent={
                            <SearchableList
                              label="Select Plan"
                              options={selectPlanOptions}
                              onSelect={(value) => onPlanChange(value)}
                              // selectedValue={selectPlanOptions.findIndex(
                              //   (_) => {
                              //     const planName =
                              //       planList?.length > 1
                              //         ? values[fields.planName]
                              //           ? values[fields.planName]
                              //           : values[fields.companyName] && "All"
                              //         : planList[0]?.planName;

                              //     return planName === _.label;
                              //   }
                              // )}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </div>

                      <div className="d-flex ml-3 mr-2">
                        <div style={{ position: "relative", display: "flex" }}>
                          <Field
                            size="sm"
                            //label="&nbsp;"
                            placeholder="Search SSN, Name"
                            label="Search"
                            isRequired
                            name={fields.nameOrSsn}
                            type="text"
                            autoComplete="off"
                            value={values[fields.nameOrSsn]}
                            onChange={handleChange}
                            component={FieldInput}
                          />
                          {values[fields.nameOrSsn] &&
                            values[fields.nameOrSsn].length != 0 && (
                              <div
                                style={{
                                  position: "absolute",
                                  right: "5px",
                                  height: "100%",
                                  paddingTop: "35px",
                                  marginRight: "5px",
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faTimes}
                                  color="#000"
                                  size="sm"
                                  onClick={() => {
                                    setFieldValue(fields.nameOrSsn, "");
                                  }}
                                />
                              </div>
                            )}
                        </div>
                      </div>
                      <div className="d-flex ml-4 mr-2">
                        <Field
                          size="sm"
                          label="Pay date from"
                          isRequired
                          name={fields.fromDate}
                          value={usDateFormat(values[fields.fromDate])}
                          direction="bottom"
                          isDatePicker
                          onClear={() => setFieldValue(fields.fromDate, null)}
                          popupContent={
                            <DatePicker
                              onDayClick={(value) =>
                                onDaySelected(fields.fromDate, value)
                              }
                              value={usDateFormat(values[fields.fromDate])}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </div>
                      <div className="d-flex ml-3 mr-2">
                        <Field
                          size="sm"
                          label="Pay date to"
                          isRequired
                          name={fields.toDate}
                          value={usDateFormat(values[fields.toDate])}
                          direction="bottom"
                          isDatePicker
                          onClear={() => setFieldValue(fields.toDate, null)}
                          popupContent={
                            <DatePicker
                              onDayClick={(value) =>
                                onDaySelected(fields.toDate, value)
                              }
                              value={usDateFormat(values[fields.toDate])}
                            />
                          }
                          validate={(value) => {
                            return [undefined, null, ""].includes(value) ? (
                              ""
                            ) : value < values[fields.fromDate] ? (
                              <div style={{ width: "100px" }}>
                                {" "}
                                Should be ahead of "Pay date from"
                              </div>
                            ) : //? "PL559 : Pay Date From must be greater than Pay Date to"
                            undefined;
                          }}
                          component={FieldDropSide}
                        />
                      </div>
                    </div>
                    <Button
                      className=" mt-12 sort-button"
                      variant="secondary"
                      style={{
                        marginLeft: "8px",
                        marginTop: "30px",
                      }}
                      onClick={(e) => {
                        setValues({
                          ...clearFieldValues({
                            values,
                            fieldsToClear: [
                              fields.planId,
                              fields.planName,
                              fields.companyId,
                              fields.companyName,
                              fields.sponsorOrganizationName,
                              fields.sponsorOrganizationId,
                              fields.fromDate,
                              fields.toDate,
                            ],
                          }),
                        });
                        setFieldValue(fields.nameOrSsn, "");
                        setFieldValue(fields.planName, null);
                        setFieldValue(fields.planId, null);
                        setFieldValue(fields.fromDate, initialValues.fromDate);
                        setFieldValue(fields.toDate, initialValues.toDate);
                        setPlanList([]);
                        setErrors({});
                        setTotalRecord(0);
                        setTableContent([]);
                        setCompanyList("");
                        setSponOrgList("");
                      }}
                    >
                      Reset
                    </Button>
                    <Button
                      className="ml-2 mt-12 sort-button"
                      style={{
                        lineHeight: "19px",
                        marginRight: "30%",
                        marginTop: "30px",
                      }}
                      variant="secondary"
                      type="submit"
                    >
                      Search
                    </Button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
        <div className="d-flex justify-content-between align-center divSpace header-button min-width-200">
          <div className="d-flex flex-col">
            <div
              style={{ fontSize: "14px", color: "#828282", paddingTop: "6px" }}
            >
              {companyList ? `Showing result for ${companyList} company` : null}
            </div>
            <div className="ft-12 grey-text font-weight-500">
              {totalRecord} Records found
            </div>
          </div>
          <div className="d-flex pad-top-10">
            <div style={{ diplay: "flex", flexDirection: "column" }}>
              <div>
                <Button
                  variant="secondary"
                  className="column-header"
                  onClick={showManageColumns}
                >
                  <span className="marg-right-6">
                    <i class="fal fa-columns"></i>
                  </span>
                  Column
                </Button>
              </div>
              <div
                className="manage-column-dropdown"
                style={{ display: "none" }}
              >
                <div className="manage-columns ">
                  <p className="manage-columns-button"> Manage columns</p>
                  <p
                    className="apply-button"
                    onClick={() => {
                      hideColumns();
                      setTrigger(!trigger);
                    }}
                  >
                    Close
                  </p>
                </div>
                <div>
                  <MultiSelectDropdown
                    hideSelectedOptions="FALSE"
                    //width="269px"
                    height="200px"
                    maxHeight="300px"
                    position="absolute"
                    background="white"
                    zIndex="2"
                    overflow={true}
                    options={columns}
                    onSelect={(value) => {
                      setSelectedColumns(value);
                    }}
                    name={"Columns"}
                    value={selectedColumns}
                    trigger={trigger}
                    // disabled={}
                    // isTypeAhead={isEdit}
                  />
                </div>
                <div style={{ marginTop: "220px", paddingLeft: "100px" }}>
                  <Button onClick={applyColumns}>Apply</Button>
                </div>
              </div>
            </div>
            <div className="ft-12 grey-text font-weight-500 marg-right-5">
              <Button
                className="export-button"
                title="Export Excel"
                variant="secondary"
                style={{ border: "none" }}
                //onClick={excelExport}
                onClick={() => !isEmpty(tableContent) && exportReportFile()}
              >
                <Image src={ExcelImage} width="20px" />
                Export
              </Button>
            </div>
          </div>
        </div>
        <div className="table-width grid-overflow" style={{ minWidth: "0px" }}>
          <ExcelExport data={tableContent}>
            <LoaderWrapper isLoading={dataLoading}>
              <Tooltip
                openDelay={100}
                position="bottom"
                anchorElement="element"
              >
                <Grid
                  data={tableContent}
                  total={tableContent.length}
                  resizable={true}
                  onScroll={scrollHandler}
                  style={{ height: "400px" }}
                  fixedScroll
                >
                  {final.map((column, idx) => (
                    <GridColumn
                      key={idx}
                      field={column.field}
                      width={column.width}
                      title={column.label}
                      filter={column.dataType}
                      cell={
                        (column.dataType === "amount" &&
                          KendoGridDecimalCell) ||
                        (column.dataType === "date" && dateFieldRender) ||
                        (column.dataType === "boolean" && booleanFieldRender) ||
                        (column.dataType === "numeric" && numericFieldRender) ||
                        renderValue
                      }
                      headerCell={ProductNameHeader}
                      columnMenu={(props) =>
                        !isEmpty(tableContent) ||
                        (gridFilters &&
                          (gridFilters[column.field1] ||
                            (column.field2 && gridFilters[column.field2]))) ? (
                          <GridInnerFilters
                            {...props}
                            fields={fields}
                            sorting={sorting}
                            setSorting={setSorting}
                            gridFilters={gridFilters}
                            setGridFilters={setGridFilters}
                            field1={column.field1}
                            field2={column.field2 ? column.field2 : null}
                            columns={selectedColumns}
                          />
                        ) : null
                      }
                    />
                  ))}
                </Grid>
              </Tooltip>
            </LoaderWrapper>
          </ExcelExport>
        </div>
      </div>
    </ManageReportLayout>
  );
};

export default CompensationHoursLoansReport;
